import '../styles/components/QuestionAnswer.scss';
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";

const QuestionAnswer = ({ index, question, answers, displayAnswer, setDisplayAnswer }) => {
    return (
        <div className="question-container" onClick={() => setDisplayAnswer(displayAnswer ? null : index)}>
            <div className="question">
                <h3> {question} </h3>
                {displayAnswer ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
            </div>
            {displayAnswer &&
                <div className='answer'>
                    {answers.map((answer, index) => (
                        <span key={index}> {answer} </span>
                    ))}
                </div>
            }
        </div>
    );
}

export default QuestionAnswer;